export default "__VITE_ASSET__BhIAmpqj__"